import React from "react";
//#region types
import { RefreshButtonProps } from "models/propTypes/commonPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import RoundButton from "./roundButton";
import Icon from "../icon";
//#endregion

const RefreshButton: React.FC<RefreshButtonProps> = (props) => {
  const [refreshing, setRefreshing] = React.useState<boolean>(false);
  const onClick = () => {
    setRefreshing(true);
    props.onClick().then((res) => {
      props.onChange(res);
      setRefreshing(false);
    });
  };
  return (
    <Grid item container style={{ height: 56 }} alignItems={"center"} justifyContent={"flex-end"}>
      <RoundButton size="sm" onClick={onClick} disabled={refreshing}>
        <Icon icon={IconDefinitionConstants.WRepeat} />
      </RoundButton>
    </Grid>
  );
};

export default RefreshButton;
